import styled, {css} from 'styled-components'

const Style = {
	Aside: styled.aside`
		display: ${({$isMobileDrawer}) => ($isMobileDrawer ? 'flex' : 'none')};
		flex-direction: column;
		flex-basis: 200px;
		flex-shrink: 0;
		position: relative;
		padding: 24px 10px 24px 20px;
		height: ${({$isMobileDrawer}) => ($isMobileDrawer ? '100%' : 'auto')};

		${({$isMobileDrawer, theme}) =>
			!$isMobileDrawer &&
			css`
				border-top: 1px solid ${theme.color.grey1};
			`}

		@media (min-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: ${({$isMobileDrawer}) => ($isMobileDrawer ? 'none' : 'flex')};
			border-top: 1px solid ${({theme}) => theme.color.grey1};
			height: calc(100dvh - 80px);
			overflow-y: hidden;
		}
	`,
	MenuList: styled.div`
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: ${({maxHeight}) => `calc(100% - ${maxHeight})`};
		overflow-y: auto;
		scrollbar-width: thin;
	`,
	CategoryDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;

		& > h2 {
			${({theme}) => theme.font.extra_small_bold}
			padding-bottom: 4px;
		}
	`,
	Element: styled.button`
		color: ${({theme}) => theme.color.grey4};
		${({theme}) => theme.font.extra_small};
		text-align: left;

		${({$nowPage}) =>
			$nowPage &&
			css`
				color: ${({theme}) => theme.color.major};
				${({theme}) => theme.font.extra_small_bold};
			`}
	`,
	ButtonContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 12px;
		justify-content: end;
		height: fit-content
		position: absolute;
		bottom: 0;
		left: 0;
	`,
	EditBtn: styled.button`
		width: 100%;
		background-color: ${({theme}) => theme.color.grey3};
		color: ${({theme}) => theme.color.white};
		${({theme}) => theme.font.extra_small_bold};
		padding: 18px 0;
	`,
	DownloadBtn: styled.div`
		width: 100%;
	`,
	LogoutBtn: styled.button`
		width: 100%;
		background-color: ${({theme}) => theme.color.grey4};
		color: ${({theme}) => theme.color.white};
		${({theme}) => theme.font.extra_small_bold};
		padding: 18px 0;
	`,
}

export default Style
